
import { GET_ALERTS_LEGEND,
    GET_LAYER_LEGEND,
    GET_MAP_LAYERS,
    GET_MAP_METADATA } from '../actions/mapActions';

export const initialState = {
    isFetchingMapLayers: false,
    isFetchingMapMetadata: false,
    isFetchingLayerLegend: false,
    isFetchingAlertsLegend: false,
    layers: [],
    defaultLayer: undefined,
    fetchLayersError: undefined,
    fetchMetadataError: undefined,
    fetchLegendError: undefined,
    fetchAlertsLegendError: undefined
};

export function map(state = initialState, action) {
    switch (action.type) {
        case GET_MAP_LAYERS.pending:
        {
            return {
                ...state,
                isFetchingMapLayers: true
            };
        }
        case GET_MAP_LAYERS.fulfilled:
        {
            return {
                ...state,
                layers: action.payload?.layers || [],
                defaultLayer: action.payload?.defaultLayer || undefined,
                fetchLayersError: undefined,
                isFetchingMapLayers: false
            };
        }
        case GET_MAP_LAYERS.rejected:
        {
            return{
                ...state,
                fetchLayersError: action.payload,
                isFetchingMapLayers: false
            };
        }
        case GET_MAP_METADATA.pending:
        {
            return {
                ...state,
                metadata: undefined,
                isFetchingMapMetadata: true
            };
        }
        case GET_MAP_METADATA.fulfilled:
        {
            return {
                ...state,
                metadata: action.payload,
                fetchMetadataError: undefined,
                isFetchingMapMetadata: false
            };
        }
        case GET_MAP_METADATA.rejected:
        {
            return{
                ...state,
                fetchMetadataError: action.payload,
                isFetchingMapMetadata: false
            };
        }
        case GET_LAYER_LEGEND.pending:
        {
            return {
                ...state,
                legend: undefined,
                isFetchingLayerLegend: true
            };
        }
        case GET_LAYER_LEGEND.fulfilled:
        {
            return {
                ...state,
                legend: action.payload?.val,
                fetchLegendError: undefined,
                isFetchingLayerLegend: false
            };
        }
        case GET_LAYER_LEGEND.rejected:
        {
            return{
                ...state,
                fetchLegendError: action.payload,
                isFetchingLayerLegend: false
            };
        }
        case GET_ALERTS_LEGEND.pending:
        {
            return {
                ...state,
                alertsLegend: undefined,
                isFetchingAlertsLegend: true
            };
        }
        case GET_ALERTS_LEGEND.fulfilled:
        {
            return {
                ...state,
                alertsLegend: {Result: action.payload},
                fetchAlertsLegendError: undefined,
                isFetchingAlertsLegend: false
            };
        }
        case GET_ALERTS_LEGEND.rejected:
        {
            return{
                ...state,
                fetchAlertsLegendError: action.payload,
                isFetchingAlertsLegend: false
            };
        }
        default:
        {
            return state;
        }
    }
}
